import {useCallback} from "react";
import {useHistory} from "react-router";

import type {IPromotionUrlRegion} from "../../helpers/build_friendly_promotion_slug";
import {buildPromotionListUrl, buildPromotionListUrlFromRegion} from "../../helpers/build_promotion_list_url";
import {PromotionType} from "../../helpers/PromotionType";

export const usePromotionListFilterChange = (): ((type?: PromotionType, region?: IPromotionUrlRegion | string) => void) => {
    const history = useHistory();

    return useCallback((type?: PromotionType, region?: IPromotionUrlRegion | string) => {
        if (typeof region === "string") {
            history.push(buildPromotionListUrl({region, type}));
            return;
        }

        history.push(buildPromotionListUrlFromRegion({region, type}));
    }, []);
};
import {useCallback} from "react";
import {useHistory} from "react-router";

import type {IPromotionUrlRegion} from "../../helpers/build_friendly_promotion_slug";
import {buildPromotionListUrl, buildPromotionListUrlFromRegion} from "../../helpers/build_promotion_list_url";
import {PromotionType} from "../../helpers/PromotionType";

export const usePromotionListFilterChange = (): ((type?: PromotionType, region?: IPromotionUrlRegion | string) => void) => {
    const history = useHistory();

    return useCallback((type?: PromotionType, region?: IPromotionUrlRegion | string) => {
        if (typeof region === "string") {
            history.push(buildPromotionListUrl({region, type}));
            return;
        }

        history.push(buildPromotionListUrlFromRegion({region, type}));
    }, []);
};
